import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const RedirectHashToEvent = () => {
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;

    const fullUrl = decodeURIComponent(window.location.href);
    const hashIndex = fullUrl.indexOf("#");

    if (hashIndex !== -1) {
      const hashPart = fullUrl.substring(hashIndex + 1); // remove #
      const eventId = hashPart.split("?")[0]; // remove query params like fbclid

      if (eventId) {
        console.log("Redirecting to event ID:", eventId);
        hasRedirected.current = true;
        navigate(`/hangout/${eventId}`);
        return;
      }
    }

    // fallback
    console.warn("No valid hash found, redirecting to home.");
    navigate("/");
  }, [navigate]);

  return null;
};
